<img class="{{ classType }}" (error)="updateUrl($event)" [src]="imageSrc" />
<div *ngIf="userName" class="user-name">
  <div class="user-name-inner">
    {{ userName }}
  </div>
</div>
